import { SessionStorageKeys, useSessionStorage } from '@/utils/storage.ts';
import { Language } from '@/api/types.ts';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';

export const DEFAULT_LANGUAGE = 'english';

export const languageToLocale: Record<Language, string> = {
  english: 'en',
  spanish: 'es',
  russian: 'ru',
};

export const useAppLanguage = () => {
  const [language, _setLanguage] = useSessionStorage<Language>(
    SessionStorageKeys.SELECTED_LANGUAGE,
    DEFAULT_LANGUAGE
  );
  const { i18n: { changeLanguage } } = useTranslation();

  useEffect(() => {
    changeLanguage(languageToLocale[language] ?? language);
  }, [language]);

  const setLanguage = useCallback((value: Language) => {
    _setLanguage(value);
    changeLanguage(languageToLocale[value] ?? value);
  }, [_setLanguage, changeLanguage]);

  return [language, setLanguage, _setLanguage] as const;
}
